export default __webpack_public_path__ + "static/media/General's Belt of the Watchtowers.970cdb53.jpg";